import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=14ebf32e&scoped=true&"
import script from "./noticeDetail.vue?vue&type=script&lang=js&"
export * from "./noticeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ebf32e",
  null
  
)

export default component.exports